// Copyright 2023, Avation Medical. All rights reserved.
// 
// This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
// or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.

import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/core/http/account/account.service';
import { IconService } from 'src/app/core/services/icon.service';
import { handleBadRequest } from 'src/app/shared/helpers/bad-request-handler';
import { APIError } from 'src/app/shared/models/api-error.interface';
import { ChangePasswordModel } from 'src/app/shared/models/login';
import { confirmPassword } from 'src/app/shared/validators';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent implements OnInit {
  loading: boolean = false;
  hidePasswordOld = true;
  hidePasswordNew = true;
  hidePasswordConfirm = true;
  errorStr: string = null;

  changePasswordForm = this.fb.group({
    oldPassword: ['', [Validators.required]],
    newPassword: ['', [Validators.required]],
    confirmPassword: ['']
  }, { validators: confirmPassword('newPassword', 'confirmPassword') });

  constructor(
    private readonly fb: FormBuilder,
    private readonly accountService: AccountService,
    private readonly router: Router,
    private readonly iconService: IconService,
  ) { this.iconService.registerIcons(); }

  ngOnInit(): void {
  }

  async submitForm() {
    this.loading = true;
    let data = this.changePasswordForm.value as ChangePasswordModel;

    await this.accountService.changePassword(data).toPromise()    
      .then(_ => this.router.navigate(['/']))
      .catch(response => {
        this.loading = false;
        if (response.error) {
          let apiError: APIError = response.error;
          this.errorStr = apiError[""][0];
        }
        handleBadRequest(this.changePasswordForm, response);
      });
  }
}
